import React from 'react';
import PersonalInfo from './PersonalInfo';
import ContactInfo from './ContactInfo';
import EmploymentInfo from './EmploymentInfo';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import Skeleton from '../skeleton/personalInfoSkeleton';

import '../styles/profile.scss';

const UserProfile = ({
  loader,
  employeeInfo,
  loggedInMemberType,
  residentialAddress,
  mailingAddress,
  PhoneEmailInfo,
  employmentDetails,
  serverError,
  onClickEdit,
  showEditButton = true,
}) => {
  return (
    <div className="my-profile-member-container">
      <div>
        <h2 className="row-title" tabIndex={0}>
          Personal Information
        </h2>
      </div>

      {loader ? (
        <Skeleton />
      ) : !serverError ? (
        <div className="bg-white p-4 all-profile-component-wrapper">
          <PersonalInfo
            loader={loader}
            employeeInfo={employeeInfo}
            loggedInMemberType={loggedInMemberType}
          />
          <ContactInfo
            loader={loader}
            residentialAddress={residentialAddress}
            mailingAddress={mailingAddress}
            PhoneEmailInfo={PhoneEmailInfo}
            onClickEdit={onClickEdit}
            showEditButton={showEditButton}
          />
          {'Employee' == loggedInMemberType && (
            <EmploymentInfo
              loader={loader}
              employmentDetails={employmentDetails}
            />
          )}
        </div>
      ) : (
        <CustomClientError
          ErrorHeading="Something went wrong with request!"
          ErrorMessage="Please try again."
        />
      )}
    </div>
  );
};

export default UserProfile;
